import Container from '@styles/Container'
import slugify from 'slugify'
import styled from 'styled-components'
import { H4 } from '@components/Heading'
import { up } from 'styled-breakpoints'

const StyledSkill = styled.div`
  --gap: 6rem;
  column-gap: var(--gap);
  display: grid;
  align-items: center;

  img {
    max-height: 35re;
  }

  ${up('md')} {
    grid-template-columns: 46% 1fr;
  }

  ${up('lg')} {
    --gap: 12rem;
    column-gap: var(--gap);
  }
`

const StyledTitle = styled(H4)`
  margin: 0 0 2.4rem;
`

const StyledDescription = styled.p`
  font-size: 2rem;
  line-height: 4rem;
  letter-spacing: 0.02rem;
  color: var(--gray-5);
  font-weight: 400;
  font-family: 'Neue Montreal';
  margin-bottom: 8rem;
`

const StyledProjectTitle = styled.h3`
  font-size: 2.4rem;
  font-weight: 500;
  line-height: 3.2rem;
  letter-spacing: -0.05rem;
  margin: 0 0 0.8rem;
`

const StyledProjectDescription = styled.p`
  font-size: 1.6rem;
  font-family: 'Neue Montreal';
  line-height: 3.2rem;
  letter-spacing: 0.02rem;
`

const StyledProjects = styled.div`
  > *:not(:last-child) {
    margin-bottom: 4.8rem;
  }
`

type IProps = {
  imageSrc: string
  title: string
  description: string
  projects: Array<{ title: string; description: string }>
}

const Skill = ({ imageSrc, title, description, projects }: IProps) => (
  <Container id={slugify(title, { lower: true })}>
    <StyledSkill>
      <div>
        <img src={imageSrc} alt={title} />
      </div>
      <div>
        <StyledTitle as="h2">{title}</StyledTitle>
        {description && <StyledDescription>{description}</StyledDescription>}
        {projects.length && (
          <StyledProjects>
            {projects.map((project) => (
              <div key={project.title}>
                <StyledProjectTitle>{project.title}</StyledProjectTitle>
                <StyledProjectDescription>
                  {project.description}
                </StyledProjectDescription>
              </div>
            ))}
          </StyledProjects>
        )}
      </div>
    </StyledSkill>
  </Container>
)

export default Skill
